import { CommonEnums } from '../../common.enums';
import { DxMp_Fwd_Lnk } from './dxmp_fwd_lnk.';
import { DxMp } from './dxmp';
import { Param } from './param';
import { DxFlow_Obj_Property } from './dxflow_obj_property';
import { Obj_Db_Property } from '../datapoint/obj_db_property';
import { DBSeq } from '../objects/dbseq';
import { DBFun } from '../objects/dbfun';

import { Db_PropertyType } from '../datapoint/dbPropertyType';
import { TNode } from './tnode';
import { RepConn } from '../datapoint/repconn';
import { DxMp_Fwd_LnksUtil } from 'src/app/shared/utils/dxmp_fwd_lnks.util';
import { DxFlow_Obj_PropertiesUtil } from 'src/app/shared/utils/dxflow_obj_properties.util';
import { TransformsUtil } from 'src/app/modules/design/transforms/transforms.util';
import { ParamsUtil } from 'src/app/shared/models/utils/params.util';
import { Obj_Db_PropertiesUtil } from '../../utils/obj_db_properties.util';
import { ArrayUtil } from '../utils/array.util';
import { Db_PropertyTypesUtil } from '../../utils/db_propertytypes.util';
import { TNodesUtil } from '../utils/tnodes.util';
import { UDF } from './udf';
import { DBFunUtil } from 'src/app/modules/dbfun/dbfun.util';
import { DBSeqUtil } from 'src/app/modules/dbseq/dbseq.util';
import { UDFUtil } from 'src/app/modules/udf/udf.util';
import { CanvasComment } from './canvas-comment';
import { CanvasCommentUtil } from '../../utils/canvascomment.util';

export class Design {
    dxMp: DxMp;
    fldr_Id: number;
    params: Array<Param>;
    sqlParams: Array<Param>;
    projectParams: Array<Param>;

    comments : Array<CanvasComment>;

    objects: Array<any>;
    dxMp_Fwd_Lnks: Array<DxMp_Fwd_Lnk>;

    dxFlow_Obj_Properties: Array<DxFlow_Obj_Property>;

    sel_Run_PropertyType_Cd: string;
    run_Properties: Array<Obj_Db_Property>;
    runPropertyTypes: Array<Db_PropertyType>;

    reusableFlag: string
    dependent_Ids: Array<number>;
    dBSeqs: Array<DBSeq>;
    udfs: Array<UDF>;
    dbFuns: Array<DBFun>;

    recExists: boolean;
    lockBy: string;
    mode_Ind: string;
    change_Ind: string;
    unlock_Ind: string;
    error_Cd: string;
    error_Msg: string;
    ref_Id: number;
    ref_Cd: string;
    dependent: boolean;
    linkExist: boolean;
    fldrNm: string;
    layerNm: string;
    linkLayer_Id: number;
    imageUrl: string;

    selectedFlag: string;
    fldr_Cd: string;
    repConn: RepConn;
    ntvConn_Id: number;
    viewPrivilegeFlg: string;
    admin_LogLevel: string;

    transformCoordinates: Array<TNode>;

    max_dbg_view_data_limit: string;
    default_dbg_view_data_limit: string;

    spark_dsa: string;
    jobFlowRun: boolean;
    performanceFlag: boolean;
    attrNmMappings: Map<string, string>;
    ntvGenFlag: boolean;
    dmwMode: string;

    gen_Tab_Change_Ind: string;
    prop_Tab_Change_Ind: string;
    dprm_Tab_Change_Ind: string;
    sprm_Tab_Change_Ind: string;
    lorder_Tab_Change_Ind: string;
    rProp_Tab_Change_Ind: string;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.dxMp = new DxMp();
        this.fldr_Id = CommonEnums.defaults.LONG_VAL;
        this.params = new Array<Param>();
        this.sqlParams = new Array<Param>();
        this.projectParams = new Array<Param>();
        this.comments  = new Array<CanvasComment>();
        this.objects = new Array<any>();
        this.dxMp_Fwd_Lnks = new Array<DxMp_Fwd_Lnk>();
        this.dxFlow_Obj_Properties = new Array<DxFlow_Obj_Property>();
        this.run_Properties = new Array<Obj_Db_Property>();
        this.reusableFlag = CommonEnums.reusableFlag.NO;
        this.dependent_Ids = new Array<any>();
        this.dBSeqs = new Array<DBSeq>();
        this.udfs = new Array<UDF>();
        this.dbFuns = new Array<DBFun>();
        this.recExists = false;
        this.lockBy = CommonEnums.defaults.STRING_EMPTY;
        this.mode_Ind = CommonEnums.mode_Ind.WRITE;
        this.change_Ind = CommonEnums.defaults.STRING_EMPTY;
        this.unlock_Ind = CommonEnums.defaults.STRING_EMPTY;
        this.error_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.error_Msg = CommonEnums.defaults.STRING_EMPTY;
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.dependent = false;
        this.linkExist = false;
        this.fldrNm = CommonEnums.defaults.STRING_EMPTY;
        this.layerNm = CommonEnums.defaults.STRING_EMPTY;
        this.linkLayer_Id = CommonEnums.defaults.LONG_VAL;
        this.imageUrl = CommonEnums.defaults.STRING_EMPTY;
        this.runPropertyTypes = new Array<Db_PropertyType>();
        this.sel_Run_PropertyType_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.selectedFlag = CommonEnums.defaults.STRING_EMPTY;
        this.fldr_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.repConn = new RepConn();
        this.ntvConn_Id = CommonEnums.defaults.LONG_VAL;
        this.viewPrivilegeFlg = CommonEnums.defaults.STRING_EMPTY;
        this.admin_LogLevel = CommonEnums.defaults.STRING_EMPTY;
        this.transformCoordinates = new Array<TNode>();
        this.max_dbg_view_data_limit = CommonEnums.defaults.STRING_EMPTY;
        this.default_dbg_view_data_limit = CommonEnums.defaults.STRING_EMPTY;
        this.spark_dsa = CommonEnums.defaults.STRING_EMPTY;
        this.jobFlowRun = false;
        this.performanceFlag = false;
        this.attrNmMappings = new Map<string, string>(); // HashMap<string, string>
        this.ntvGenFlag = false;
        this.dmwMode = CommonEnums.defaults.STRING_EMPTY;

        this.resetTab_Change_Ind();
    }

    resetTab_Change_Ind(): void {
        this.gen_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.prop_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.dprm_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.sprm_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.lorder_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.rProp_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
    }

    static parse(designTmp: Design): Design {
        let design: Design = new Design();
        design.copyFrom(designTmp as Design);
        return design;
    }

    copy(): Design {
        let designTmp: Design = new Design();

        designTmp.fldr_Id = this.fldr_Id;

        designTmp.dxMp = this.dxMp.copy();

        let paramsUtil: ParamsUtil = ParamsUtil.getInstance();
        designTmp.params = paramsUtil.copy(this.params);
        designTmp.sqlParams = paramsUtil.copy(this.sqlParams);
        designTmp.projectParams = paramsUtil.copy(this.projectParams);
        designTmp.comments = CanvasCommentUtil.getInstance().copy(this.comments);
        designTmp.objects = TransformsUtil.getInstance().copy(this.objects);
        designTmp.dxMp_Fwd_Lnks = DxMp_Fwd_LnksUtil.getInstance().copy(this.dxMp_Fwd_Lnks);
        designTmp.dxFlow_Obj_Properties = DxFlow_Obj_PropertiesUtil.getInstance().copy(this.dxFlow_Obj_Properties);

        designTmp.run_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.run_Properties);

        designTmp.reusableFlag = this.reusableFlag;
        designTmp.dependent_Ids = ArrayUtil.getInstance().copy(this.dependent_Ids);

        designTmp.dBSeqs = DBSeqUtil.getInstance().copy(this.dBSeqs); // this.dBSeqs;
        designTmp.udfs = UDFUtil.getInstance().copy(this.udfs); // this.udfs;
        designTmp.dbFuns = DBFunUtil.getInstance().copy(this.dbFuns); // this.dbFuns;

        designTmp.recExists = this.recExists;
        designTmp.lockBy = this.lockBy;
        designTmp.mode_Ind = this.mode_Ind;
        designTmp.change_Ind = this.change_Ind;
        designTmp.unlock_Ind = this.unlock_Ind;
        designTmp.error_Cd = this.error_Cd;
        designTmp.error_Msg = this.error_Msg;
        designTmp.ref_Id = this.ref_Id;
        designTmp.ref_Cd = this.ref_Cd;
        designTmp.dependent = this.dependent;
        designTmp.linkExist = this.linkExist;
        designTmp.fldrNm = this.fldrNm;
        designTmp.layerNm = this.layerNm;
        designTmp.linkLayer_Id = this.linkLayer_Id;
        designTmp.imageUrl = this.imageUrl;
        designTmp.runPropertyTypes = Db_PropertyTypesUtil.getInstance().copy(this.runPropertyTypes);
        designTmp.sel_Run_PropertyType_Cd = this.sel_Run_PropertyType_Cd;
        designTmp.selectedFlag = this.selectedFlag;
        designTmp.fldr_Cd = this.fldr_Cd;
        designTmp.repConn = this.repConn;
        designTmp.ntvConn_Id = this.ntvConn_Id;
        designTmp.viewPrivilegeFlg = this.viewPrivilegeFlg;
        designTmp.admin_LogLevel = this.admin_LogLevel;
        designTmp.transformCoordinates = TNodesUtil.getInstance().copy(this.transformCoordinates);
        designTmp.max_dbg_view_data_limit = this.max_dbg_view_data_limit;
        designTmp.default_dbg_view_data_limit = this.default_dbg_view_data_limit;
        designTmp.spark_dsa = this.spark_dsa;
        designTmp.jobFlowRun = this.jobFlowRun;
        designTmp.performanceFlag = this.performanceFlag;
        // designTmp.attrNmMappings = this.attrNmMappings;
        ///      designTmp.attrNmMappings = ArrayUtil.getInstance().copy(this.dependent_Ids);
        designTmp.ntvGenFlag = this.ntvGenFlag;
        designTmp.dmwMode = this.dmwMode;

        designTmp.gen_Tab_Change_Ind = this.gen_Tab_Change_Ind;
        designTmp.prop_Tab_Change_Ind = this.prop_Tab_Change_Ind;
        designTmp.dprm_Tab_Change_Ind = this.dprm_Tab_Change_Ind;
        designTmp.sprm_Tab_Change_Ind = this.sprm_Tab_Change_Ind;
        designTmp.lorder_Tab_Change_Ind = this.lorder_Tab_Change_Ind;
        designTmp.rProp_Tab_Change_Ind = this.rProp_Tab_Change_Ind;

        return designTmp;
    }

    copyFrom(designTmp: Design): void {
        this.fldr_Id = designTmp.fldr_Id;
        this.dxMp.copyFrom(designTmp.dxMp)

        let paramsUtil: ParamsUtil = ParamsUtil.getInstance();
        paramsUtil.copyFrom(this.params, designTmp.params);
        paramsUtil.copyFrom(this.sqlParams, designTmp.sqlParams);
        paramsUtil.copyFrom(this.projectParams, designTmp.projectParams);
        CanvasCommentUtil.getInstance().copyFrom(this.comments, designTmp.comments);

        DxMp_Fwd_LnksUtil.getInstance().copyFrom(this.dxMp_Fwd_Lnks, designTmp.dxMp_Fwd_Lnks);

        DxFlow_Obj_PropertiesUtil.getInstance().copyFrom(this.dxFlow_Obj_Properties, designTmp.dxFlow_Obj_Properties);
        TransformsUtil.getInstance().copyFrom(this.objects, designTmp.objects);
        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.run_Properties, designTmp.run_Properties);

        ArrayUtil.getInstance().copyFrom(this.dependent_Ids, designTmp.dependent_Ids);
        // this.dependent_Ids = designTmp.dependent_Ids;
        this.reusableFlag = designTmp.reusableFlag;

        DBSeqUtil.getInstance().copyFrom(this.dBSeqs, designTmp.dBSeqs);  // this.dBSeqs = designTmp.dBSeqs;
        UDFUtil.getInstance().copyFrom(this.udfs, designTmp.udfs);  // this.udfs = designTmp.udfs;
        DBFunUtil.getInstance().copyFrom(this.dbFuns, designTmp.dbFuns); // this.dbFuns = designTmp.dbFuns;

        this.recExists = designTmp.recExists;
        this.lockBy = designTmp.lockBy;
        this.mode_Ind = designTmp.mode_Ind;
        this.change_Ind = designTmp.change_Ind;
        this.unlock_Ind = designTmp.unlock_Ind;
        this.error_Cd = designTmp.error_Cd;
        this.error_Msg = designTmp.error_Msg;
        this.ref_Id = designTmp.ref_Id;
        this.ref_Cd = designTmp.ref_Cd;
        this.dependent = designTmp.dependent;
        this.linkExist = designTmp.linkExist;
        this.fldrNm = designTmp.fldrNm;
        this.layerNm = designTmp.layerNm;
        this.linkLayer_Id = designTmp.linkLayer_Id;
        this.imageUrl = designTmp.imageUrl;
        Db_PropertyTypesUtil.getInstance().copyFrom(this.runPropertyTypes, designTmp.runPropertyTypes);
        this.sel_Run_PropertyType_Cd = designTmp.sel_Run_PropertyType_Cd;
        this.selectedFlag = designTmp.selectedFlag;
        this.fldr_Cd = designTmp.fldr_Cd;
        this.repConn = designTmp.repConn;
        this.ntvConn_Id = designTmp.ntvConn_Id;
        this.viewPrivilegeFlg = designTmp.viewPrivilegeFlg;
        this.admin_LogLevel = designTmp.admin_LogLevel;
        TNodesUtil.getInstance().copyFrom(this.transformCoordinates, designTmp.transformCoordinates);
        this.max_dbg_view_data_limit = designTmp.max_dbg_view_data_limit;
        this.default_dbg_view_data_limit = designTmp.default_dbg_view_data_limit;
        this.spark_dsa = designTmp.spark_dsa;
        this.jobFlowRun = designTmp.jobFlowRun;
        this.performanceFlag = designTmp.performanceFlag;
        ///      ArrayUtil.getInstance().copyFrom(this.attrNmMappings, designTmp.attrNmMappings);
        // this.attrNmMappings = designTmp.attrNmMappings;
        this.ntvGenFlag = designTmp.ntvGenFlag;
        this.dmwMode = designTmp.dmwMode;

        this.gen_Tab_Change_Ind = designTmp.gen_Tab_Change_Ind;
        this.prop_Tab_Change_Ind = designTmp.prop_Tab_Change_Ind;
        this.dprm_Tab_Change_Ind = designTmp.dprm_Tab_Change_Ind;
        this.sprm_Tab_Change_Ind = designTmp.sprm_Tab_Change_Ind;
        this.lorder_Tab_Change_Ind = designTmp.lorder_Tab_Change_Ind;
        this.rProp_Tab_Change_Ind = designTmp.rProp_Tab_Change_Ind;
    }

    compare(designTmp: Design): string {
        let diffString: string = "";

        diffString = this.dxMp.compare(designTmp.dxMp);
        if (diffString != "") return diffString;

        diffString = TransformsUtil.getInstance().compare(this.objects, designTmp.objects);
        if (diffString != "") return diffString;

        diffString = DxMp_Fwd_LnksUtil.getInstance().compare(this.dxMp_Fwd_Lnks, designTmp.dxMp_Fwd_Lnks);
        if (diffString != "") return diffString;

        diffString = ParamsUtil.getInstance().compare(this.params, designTmp.params);
        if (diffString != "") return diffString;

        return diffString;
    }

    tostring(): string {
        return "Design [fldr_Id=" + this.fldr_Id +
            ", params=" + ParamsUtil.getInstance().toString(this.params) +
            ", sqlParams=" + ParamsUtil.getInstance().toString(this.sqlParams) +
            ", projectParams =" + ParamsUtil.getInstance().toString(this.projectParams) +
            ", objects=" + TransformsUtil.getInstance().toString(this.objects) +
            ", dxMp_Fwd_Lnks=" + DxMp_Fwd_LnksUtil.getInstance().toString(this.dxMp_Fwd_Lnks) +
            ", dxFlow_Obj_Properties=" + DxFlow_Obj_PropertiesUtil.getInstance().toString(this.dxFlow_Obj_Properties) +
            ", run_Properties=" + Obj_Db_PropertiesUtil.getInstance().toString(this.run_Properties) +
            ", reusableFlag=" + this.reusableFlag +
            ", dependent_Ids=" + ArrayUtil.getInstance().toString(this.dependent_Ids) +
            ", dBSeqs=" + DBSeqUtil.getInstance().toString(this.dBSeqs) + // this.dBSeqs +
            ", udfs=" + UDFUtil.getInstance().toString(this.udfs) + // this.udfs +
            ", dbFuns=" + DBFunUtil.getInstance().toString(this.dbFuns) + // this.dbFuns +
            ", isRecExists=" + this.recExists +
            ", lockBy=" + this.lockBy +
            ", mode_Ind=" + this.mode_Ind +
            ", change_Ind=" + this.change_Ind +
            ", unlock_Ind=" + this.unlock_Ind +
            ", error_Cd=" + this.error_Cd +
            ", error_Msg=" + this.error_Msg +
            ", ref_Id=" + this.ref_Id +
            ", ref_Cd=" + this.ref_Cd +
            ", repConn=" + this.repConn +
            ", ntvConn_Id=" + this.ntvConn_Id +
            ", viewPrivilegeFlg=" + this.viewPrivilegeFlg +
            ", admin_LogLevel=" + this.admin_LogLevel +
            ", transformCoordinates=" + TNodesUtil.getInstance().toString(this.transformCoordinates) + // this.transformCoordinates +
            ", max_dbg_view_data_limit=" + this.max_dbg_view_data_limit +
            ", default_dbg_view_data_limit=" + this.default_dbg_view_data_limit +
            ", spark_dsa=" + this.spark_dsa +
            ", isJobFlowRun=" + this.jobFlowRun +
            ", performanceFlag=" + this.performanceFlag +
            ///         ", attrNmMappings=" + ArrayUtil.getInstance().toString(this.attrNmMappings) +    // this.attrNmMappings + 
            ", ntvGenFlag=" + this.ntvGenFlag +
            ", gen_Tab_Change_Ind=" + this.gen_Tab_Change_Ind +
            ", prop_Tab_Change_Ind=" + this.prop_Tab_Change_Ind +
            ", dprm_Tab_Change_Ind=" + this.dprm_Tab_Change_Ind +
            ", sprm_Tab_Change_Ind=" + this.sprm_Tab_Change_Ind +
            ", lorder_Tab_Change_Ind=" + this.lorder_Tab_Change_Ind +
            ", rProp_Tab_Change_Ind=" + this.rProp_Tab_Change_Ind + "]";
    }
}